"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createChronicLiverFailure = createChronicLiverFailure;
const events_1 = require("../../../events");
const chronicLiverFailureHbv_1 = require("../../../forms/ktx/transplantation-screening/medical-history/chronic-liver-failure/chronicLiverFailureHbv");
const chronicLiverFailureHcv_1 = require("../../../forms/ktx/transplantation-screening/medical-history/chronic-liver-failure/chronicLiverFailureHcv");
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const messages = {
    title: {
        id: "ktx.dashboard.chronic_liver_failure.title",
        defaultMessage: "Krónikus májelégtelenség"
    },
    hbv: {
        id: "ktx.dashboard.chronic_liver_failure.hbv",
        defaultMessage: "HBV"
    },
    hcv: {
        id: "ktx.dashboard.chronic_liver_failure.hcv",
        defaultMessage: "HCV"
    },
    currentState: {
        id: "ktx.dashboard.chronic_liver_failure.current_state",
        defaultMessage: "Jelenlegi státusz"
    },
    treatedEver: {
        id: "ktx.dashboard.chronic_liver_failure.treated_ever",
        defaultMessage: "Kezelést kapott-e valaha?"
    },
    treatedComment: {
        id: "ktx.dashboard.chronic_liver_failure.comment",
        defaultMessage: "Megjegyzés"
    },
    treatedType: {
        id: "ktx.dashboard.chronic_liver_failure.treated_type",
        defaultMessage: "Kezelés típusa"
    }
};
function createChronicLiverFailure(intl, options) {
    const hbv = createHbv(intl, options);
    const hcv = createHcv(intl, options);
    const content = (0, shared_1.createGroupContent)([hbv, hcv]);
    return (0, shared_1.createGroup)(intl, { label: messages.title, content });
}
function createHbv({ formatMessage, formatMessageMap }, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.medicalHistoryQueries.chronicLiverFailureHbv);
    if (event === undefined) {
        return undefined;
    }
    const currentState = formatMessageMap(chronicLiverFailureHbv_1.hbvCurrentStateMessages, event.value.hbvCurrentState);
    const treatedEver = formatMessageMap(chronicLiverFailureHbv_1.hbvTreatedEverMessages, event.value.hbvTreatedEver);
    const items = [
        {
            type: "list-item",
            label: formatMessage(messages.currentState),
            value: currentState
        },
        {
            type: "list-item",
            label: formatMessage(messages.treatedEver),
            value: treatedEver
        }
    ];
    const comment = event.value.hbvTreatedComment;
    if (comment) {
        items.push({
            type: "list-item",
            label: formatMessage(messages.treatedComment),
            value: comment
        });
    }
    return {
        type: "list",
        attachments: (0, events_1.mapEventsToAttachments)(event),
        timestamp: event.timestamp,
        origin: event.origin,
        label: formatMessage(messages.hbv),
        items
    };
}
function createHcv({ formatMessage, formatMessageMap }, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.medicalHistoryQueries.chronicLiverFailureHcv);
    if (event === undefined) {
        return undefined;
    }
    const currentState = formatMessageMap(chronicLiverFailureHcv_1.hcvCurrentStateMessages, event.value.hcvCurrentState);
    const treatedEver = formatMessageMap(chronicLiverFailureHcv_1.hcvTreatedEverMessages, event.value.hcvTreatedEver);
    const items = [
        {
            type: "list-item",
            label: formatMessage(messages.currentState),
            value: currentState
        },
        {
            type: "list-item",
            label: formatMessage(messages.treatedEver),
            value: treatedEver
        }
    ];
    if (event.value.treatedType) {
        const ts = event.value.treatedType
            .map(t => formatMessageMap(chronicLiverFailureHcv_1.treatedTypeMessages, t))
            .join(", ");
        items.push({
            type: "list-item",
            label: formatMessage(messages.treatedType),
            value: ts
        });
    }
    const comment = event.value.hcvTreatedComment;
    if (comment) {
        items.push({
            type: "list-item",
            label: formatMessage(messages.treatedComment),
            value: comment
        });
    }
    return {
        type: "list",
        attachments: (0, events_1.mapEventsToAttachments)(event),
        timestamp: event.timestamp,
        origin: event.origin,
        label: formatMessage(messages.hcv),
        items
    };
}
